import { Navigate, Outlet } from "react-router-dom";
import { RolesType } from "@/entities/user";
import { useAppSelector } from "@/shared/lib/hooks";
import { AppRoutes } from "@/shared/config/routes";
import { selectCurrentRole } from "../../model/authSelectors";

interface RoleRouteProps {
  allowedRoles: RolesType[];
  children?: React.ReactNode;
}

// Маршруты, недоступные роли, уводят на главную: на бекенде такие запросы
// всё равно отклоняются, интерфейс лишь не показывает лишнего
export const RoleRoute = ({ allowedRoles, children }: RoleRouteProps) => {
  const role = useAppSelector(selectCurrentRole);

  if (!allowedRoles.includes(role)) {
    return <Navigate to={AppRoutes.COURSES} replace />;
  }

  return <>{children ?? <Outlet />}</>;
};
